<template>
  <DataScreen :showrestartbtn="false" />
</template>

<script>
import DataScreen from "@/components/DataScreen.vue";

export default {
  name: "ShowDataView",
  data() {
    return {
      timer: null,
    };
  },
  created() {
    this.timer = setInterval(this.updatePolldata, 60000);
    this.updatePolldata();
  },
  components: {
    DataScreen,
  },
  methods: {
    updatePolldata() {
      this.$store.dispatch("updatePolldata");
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>
